import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../shared/services/language.service';


// Note : Angular has a library for this, using import '@angular/common/locales/global/fr';
// and setting LOCALE_ID on startup
// but it cannot be changed dynamically
@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }
  transform(value: Date): any {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      value = new Date(value);
    }
    return new Intl.DateTimeFormat(this.languageService.getIso2(), { year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC' }).format(value);
  }
}
